import React from 'react';

// A plus whose four arms carry four brand colours, drawn like Google Docs' "+":
// flat bars, with the top and right arms meeting on a diagonal across the centre
// square. Used on every "Add New Candidate" button; size comes from the caller's
// CSS (.plus-icon in App.css, 24px by default).
const PlusIcon = ({ className = 'plus-icon' }) => (
  <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
    <polygon points="10,0 14,0 14,10 10,14" fill="var(--part5-color)" />
    <polygon points="14,10 24,10 24,14 10,14" fill="var(--part1-color)" />
    <rect x="10" y="14" width="4" height="10" fill="#5cb85c" />
    <rect x="0" y="10" width="10" height="4" fill="var(--wylie-pink)" />
  </svg>
);

export default PlusIcon;
